// Components
import { Disclosure } from "@headlessui/react"
import { Button } from "components"

// Icons
import { MdOutlineDownloading } from "react-icons/md"
import { TbCheck, TbX } from "react-icons/tb"

// Types
import type { DataType } from "../types"

export function ImportList(params: {
  activeIndex: number
  data: DataType
  error?: string[]
  index: number
  label: string
}): JSX.Element {
  // Vars
  const { activeIndex, data, error, index } = params
  const sameIndex: boolean = activeIndex === index
  const status = {
    error: error,
    progress: sameIndex && !error,
    success: !sameIndex && !error
  }

  return (
    <Disclosure
      as="div"
      className="border p-2 rounded-lg"
    >
      <Disclosure.Button className="w-full flex justify-between items-center gap-3 p-2">
        <div className="grow text-left">{params.label}</div>

        <div>
          {activeIndex >= index && (
            <div className="border rounded">
              {status.progress ? (
                <Button
                  size="sm"
                  color="info"
                >
                  <MdOutlineDownloading size={14} />
                </Button>
              ) : status.success ? (
                <Button
                  size="sm"
                  color="primary"
                >
                  <TbCheck size={14} />
                </Button>
              ) : status.error ? (
                <Button
                  size="sm"
                  color="error"
                >
                  <TbX size={14} />
                </Button>
              ) : (
                <></>
              )}
            </div>
          )}
        </div>
      </Disclosure.Button>

      <Disclosure.Panel
        as="section"
        className="flex flex-col gap-3"
      >
        {error && (
          <section>
            <div className="text-lg font-bold">Error Messages</div>

            <ul className="list-disc list-inside text-error">
              {error.map((item, key) => <li key={key}>{item}</li>)}
            </ul>
          </section>
        )}

        <section>
          <div className="text-lg font-bold">Product Detail</div>

          <table>
            <tbody>
              {Object.keys(data).map((i, key) => (
                <tr key={key}>
                  <td className="pr-3">{i}</td>
                  <td>: {data[i]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </Disclosure.Panel>
    </Disclosure>
  )
}